export default "__VITE_ASSET__BpuqEimx__"